// IE 2026 10 16 / ODOO-5800 (Igor 16.10, скрин формы ячейки: «ось X графика VERSIONS — как у графика DETAILS · MOVEMENTS: месяцы сокращениями, текущий месяц
// выделен, под месяцами скобки годов»): ОБЩИЙ ХЕЛПЕР ОСИ МЕСЯЦЕВ — чистые функции, которыми пользуются и своя ось wijmo-графика
// (AttrChart.axisXMainRow_label / axisXMainRow_draw — рисует движком wijmo), и инлайн-SVG графика версий (cellVersionsChart_model — monthAxis_layout).
// Подпись месяца — три буквы ПОЛНОГО названия на языке интерфейса (uk: вер / жов / лис / гру / січ / лют / бер; ru: сен / окт …; en: Sep / Oct …) — так же, как
// AttrChart берёт date_Month (toLocaleString month: 'long').slice(0, 3); прореживание — шаг-делитель 12 (Jan / Apr / Jul / Oct при шаге 3), месяц ячейки (keep)
// подписан всегда, соседи ближе шага уступают ему; полоса лет — как полоса групп wijmo: линия на отрезке года, скобки вверх на границах, штрих к году в центре.
export const MONTH_AXIS = { TICK: 4, GAP: 2, BAND: 5, STUB: 4 }   // px: деление, зазор, полоса лет над годом, скобки / штрих полосы (те же, что в AttrChart.axisXMainRow_draw)
export const MONTH_STEPS = [1, 2, 3, 4, 6, 12]

export function monthAxis_label(ym, locale) {   // 'YYYY-MM[-DD]' → три буквы названия месяца на языке locale; невалидная дата — ''
    const m = /^(\d{4})-(\d{2})/.exec(String(ym || ''))
    if (!m || +m[2] < 1 || +m[2] > 12) return ''
    let s = ''
    try { s = new Date(+m[1], +m[2] - 1, 1).toLocaleString(locale || 'en', { month: 'long' }) } catch (e) { s = new Date(+m[1], +m[2] - 1, 1).toLocaleString('en', { month: 'long' }) }
    return String(s || '').slice(0, 3)
}

export function monthAxis_step(need) {   // шаг прореживания месяцев — ближайший делитель 12 не меньше need
    const n = Math.max(1, Math.ceil(Number(need) || 1))
    return MONTH_STEPS.find(v => v >= n) || 12
}

export function monthAxis_shown(months, step, keepI = -1) {   // какие месяцы подписаны: при шаге > 1 — (месяц − 1) % step === 0; keep — всегда, соседи ближе шага уступают
    const st = Math.max(1, Number(step) || 1)
    return months.map((ym, i) => {
        if (st === 1) return true
        if (i === keepI) return true
        if (keepI >= 0 && Math.abs(i - keepI) < st) return false
        const m = /^\d{4}-(\d{2})/.exec(String(ym || ''))
        return ((m ? +m[1] - 1 : i) % st) === 0
    })
}

export function monthAxis_yearBands(years) {   // отрезки одинаковых годов подряд: [{ year, i0, i1 }]
    const out = []
    const ys = (years || []).map(y => String(y === null || y === undefined ? '' : y))
    let i0 = 0
    while (i0 < ys.length) {
        let i1 = i0
        while (i1 + 1 < ys.length && ys[i1 + 1] === ys[i0]) i1++
        out.push({ year: ys[i0], i0, i1 })
        i0 = i1 + 1
    }
    return out
}

export function monthAxis_height(th) {   // высота оси под графиком: деления + подписи + полоса лет (линия, скобки, год)
    const { TICK, GAP, BAND, STUB } = MONTH_AXIS
    return Math.ceil(TICK + GAP + th + BAND + STUB + th + GAP)
}

// геометрия оси для SVG: months — 'YYYY-MM' по колонкам, x0(i) / x1(i) — границы колонки i, y0 — линия оси (низ поля графика), th — высота строки текста,
// lblW / yearW — оценка ширины подписи месяца / года (для прореживания и показа года), keepYm — месяц ячейки, locale — язык подписей
export function monthAxis_layout({ months, x0, x1, y0, th = 11, lblW = 20, yearW = 24, keepYm = '', locale = 'en', minStep = 1 }) {
    const { TICK, GAP, BAND, STUB } = MONTH_AXIS
    const n = (months || []).length
    const r1 = (v) => Math.round(v * 10) / 10
    const cw = n ? (x1(0) - x0(0)) : 0
    const step = monthAxis_step(Math.max(minStep, cw > 0 ? (lblW + 6) / cw : 1))
    const keepI = keepYm ? months.indexOf(String(keepYm).slice(0, 7)) : -1
    const shown = monthAxis_shown(months, step, keepI)
    const yl = y0 + TICK + GAP + th   // низ текста подписи месяца
    const ticks = []
    for (let i = 0; i <= n; i++) ticks.push(r1(i < n ? x0(i) : x1(n - 1)))
    const labels = months.map((ym, i) => ({ i, ym, x: r1((x0(i) + x1(i)) / 2), y: yl, text: shown[i] ? monthAxis_label(ym, locale) : '', keep: i === keepI }))
    const yb = yl + BAND
    const bands = monthAxis_yearBands(months.map(ym => String(ym || '').slice(0, 4))).map(b => {
        const xs = r1(x0(b.i0) + STUB), xe = r1(x1(b.i1) - STUB), xc = r1((xs + xe) / 2)
        const d = xe > xs ? 'M' + xs + ' ' + (yb - STUB) + ' L' + xs + ' ' + yb + ' L' + xe + ' ' + yb + ' L' + xe + ' ' + (yb - STUB) + ' M' + xc + ' ' + yb + ' L' + xc + ' ' + (yb + STUB) : ''
        return { i0: b.i0, i1: b.i1, year: b.year, xs, xe, xc, yb, d, yText: yb + STUB + th, text: (xe > xs && yearW <= xe - xs) ? b.year : '' }
    })
    return { y0, yl, tick: TICK, step, keepI, ticks, labels, bands, height: monthAxis_height(th) }
}
